
import ListComponent from "../../../components/remove_balance_records/Index.vue";

export default {
  components: {
    ListComponent
  }
}
